import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AffCode } from 'src/app/affcode/shared/affcode.model';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { AdjustmentTypeService } from 'src/app/revenue/shared/adjustment-types/adjustment-type.service';
import { BillingCycleEnum } from 'src/app/revenue/shared/billing/dto/arb-read.dto';
import { FormSettingsDto } from '../shared/dto/form-settings.dto';
import { ProfileLookupBehaviorEnum } from '../shared/enum/profile-lookup-behavior.enum';

@Component({
  selector: 'wl-form-settings',
  templateUrl: './form-settings.component.html',
  styleUrls: ['./form-settings.component.less'],
    standalone: false
})
export class FormSettingsComponent implements OnInit {
  @Input() formSettings: FormSettingsDto;
  @Input() descriptiveText: string;
  @Input() allowWriteOff = false;
  @Input() allowProfileBehavior = false;
  @Input() showLoginOptions = false;
  @Input() showOrgIndFallthroughOptions = false;
  @Input() isRenewalForm = false;

  private _showEditor = false;
  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  allAffCodes = new Array<AffCode>();
  searchAffCodesResults = new Array<AffCode>();
  adjustmentTypeOptions: Array<SelectItem>;
  revenueItemArbOptions: Array<SelectItem>;
  billingCycleEnum = BillingCycleEnum;
  profileLookupBehaviorEnum = ProfileLookupBehaviorEnum;

  constructor(private _affiliactionCodeService: AffCodeService, private _adjustmentTypeService: AdjustmentTypeService) {
    this.formSettings = {} as FormSettingsDto;
  }

  ngOnInit(): void {
    this._affiliactionCodeService.getAllAffCodes().then((data) => {
      this.allAffCodes = data.filter((x) => x.AffCode.toLowerCase() != 'all');
    });
    this.revenueItemArbOptions = Object.keys(this.billingCycleEnum)
      .filter((x) => isNaN(Number(x)))
      .filter((val) => val !== 'None')
      .map((val) => {
        return { label: val, value: this.billingCycleEnum[val] };
      });
    if (this.allowWriteOff) {
      this._adjustmentTypeService.getAdjustmentTypes().then((data) => {
        this.adjustmentTypeOptions = data.map((x) => {
          return { label: x.AdjustmentType, value: x.AdjustmentTypeId } as SelectItem;
        });
      });
    }
  }

  searchAffCodes(event: any) {
    this.searchAffCodesResults = this.allAffCodes?.filter(
      (x) =>
        x.AffCode.toLowerCase().includes(event.query?.toLowerCase()) && !this.formSettings?.AffCodes?.some((y) => x.AffCode === y.AffCode)
    );
  }

  updateApplyAffcode() {
    this.formSettings.ApplyAffCodes = this.formSettings.AffCodes.map((ac) => ac.AffCode);
  }

  // a dummy method for autocomplete to act like chips
  primeChipCompleteMethod() {}

  clearArbData() {
    this.formSettings.FormPaymentOptions.AllowArb = false;
    this.formSettings.FormPaymentOptions.ArbRequired = false;
    this.formSettings.FormPaymentOptions.CreateInvoiceChargeOnSubmit = false;
    this.formSettings.FormPaymentOptions.BillingCycle = BillingCycleEnum.None;
    this.formSettings.FormPaymentOptions.ArbText = '';
  }
}
